import { useTranslation } from "@privacy/translations";
import { Drawer } from "../../../shared/Drawer";
import { DynamicGrid } from "../../../dynamicGrid";
import { DynamicForm } from "../../../dynamicForm";
import { DpiaIcon1, RiskIcon1 } from "../../../shared/icons";
import { usePrivacyNavigate } from "../../../shared/usePrivacyNavigate";
import { measureByIdQueryOptions, measureFormQueryOptions, useUpdateMeasureAnswers } from "../../../api/measures";
import { usePermission } from "../../../shared/permissions";
import { MeasuresDrawerHeader } from "./MeasuresDrawerHeader";
import { useQuery } from "@tanstack/react-query";

export const MeasuresInlineDrawer = () => {
  const measureId = DynamicGrid.useSelectedRowId();
  const measureQuery = useQuery(measureByIdQueryOptions(measureId));
  const { t } = useTranslation();
  const { hasPermission } = usePermission();
  const { navigate, paths } = usePrivacyNavigate();
  const updateMeasureAnswersMutation = useUpdateMeasureAnswers();
  const measureFormQuery = useQuery(measureFormQueryOptions());

  const isFormReadOnly = !hasPermission("nova-forms-api:measure:update");

  return (
    <DynamicGrid.Drawer>
      {(() => {
        if (!measureQuery.data || !measureFormQuery.data) return <Drawer.Loading />;

        const measure = measureQuery.data;
        return (
          <DynamicForm.Provider
            onSave={answer => updateMeasureAnswersMutation.mutateAsync({ measureId: measure.id, answers: [answer] })}
            isSaving={updateMeasureAnswersMutation.isPending}
            isReadOnly={isFormReadOnly}
            isSaveError={updateMeasureAnswersMutation.isError}
            key={measure.id}
            answers={measure.answers}
          >
            {({ formState }) => (
              <>
                <MeasuresDrawerHeader
                  measure={measure}
                  statusIndicator={DynamicForm.formStateToDrawerHeaderStatus(formState)}
                />
                <Drawer.Content>
                  <DynamicForm.InlineForm id={measure.id} form={measureFormQuery.data} />

                  <Drawer.GoToSubDrawerButtonsWrapper>
                    <Drawer.GoToSubDrawerButton
                      Icon={DpiaIcon1}
                      count={measure.measureConnectedDpias.totalCount}
                      label={t("Measures.Drawer.SubDrawer.ConnectedDpias.Label")}
                      onClick={() => navigate(paths.measuresConnectedDpias(measure.id))}
                    />
                    <Drawer.GoToSubDrawerButton
                      Icon={RiskIcon1}
                      count={measure.measureConnectedRisks.totalCount}
                      label={t("Measures.Drawer.SubDrawer.ConnectedRisks.Label")}
                      onClick={() => navigate(paths.measuresConnectedRisks(measure.id))}
                    />
                  </Drawer.GoToSubDrawerButtonsWrapper>
                </Drawer.Content>
              </>
            )}
          </DynamicForm.Provider>
        );
      })()}
    </DynamicGrid.Drawer>
  );
};
